import type {EntryPointProps} from 'react-relay'
import {usePreloadedQuery} from 'react-relay'

import type {CleanupProjectPageUseIsReadOnlyQuery} from '../../__generated__/CleanupProjectPageUseIsReadOnlyQuery.graphql'
import {UseIsReadonlyQuery} from '../../CleanupProjectPage.queries'

import RulesContainer from './Rules.container'
import type {OuterProps} from './Rules.types'

type Queries = {
  readOnlyProjects: CleanupProjectPageUseIsReadOnlyQuery
}

export default function RulesStandalone({
  queries,
  props,
}: EntryPointProps<Queries, {}, OuterProps, {}>) {
  const {projectsRest = null} = usePreloadedQuery(UseIsReadonlyQuery, queries.readOnlyProjects)
  return <RulesContainer readOnlyProjectsKey={projectsRest} {...props} />
}
export type RulesStandaloneComponent = typeof RulesStandalone
